// TelcoTrack — shared empty-state icon (Heroicons outline inbox, viewBox 0 0 24 24).
// Single source for `app-empty-state` default glyph when no data is available.

/** Path `d` for the neutral „žádná data“ illustration. */
export const EMPTY_STATE_ICON_PATH =
  'M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4';
